<div>
<app-header></app-header>
<router-outlet></router-outlet> <!-- This is where other components will be loaded -->
<app-footer></app-footer>
</div>
